import { Avatar } from "@mui/material";

type GovernanceUserAvatarProps = {
  name: string | null;
  size?: number;
};

/**
 * Primeira letra do primeiro nome + primeira letra do segundo, quando existe.
 * "João Ferreira" → "JF"; "João" → "J".
 */
export function getInitials(name: string | null) {
  if (!name) return "?";

  const parts = name.trim().split(/\s+/);
  const initials = `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}`;

  return initials.toUpperCase() || "?";
}

export function GovernanceUserAvatar({ name, size = 32 }: GovernanceUserAvatarProps) {
  return (
    <Avatar sx={{ width: size, height: size, fontSize: `${Math.round(size * 0.4)}px`, bgcolor: "grey.400" }}>
      {getInitials(name)}
    </Avatar>
  );
}
